function isPlatformAdmin(auth: any): boolean {
  const role = auth?.user?.role;
  const roleValue = role?.value;
  return (
    roleValue === "administrator" ||
    roleValue === "super_admin" ||
    role?.isSuperAdmin === true
  );
}

function isCanvasMember(auth: any, canvas: any): boolean {
  const userId = auth?.user?.id;
  if (!userId) {
    return false;
  }
  const locations = canvas?.detail?.locations || [];
  return locations.some((location: any) =>
    (location.members || []).some((member: any) => {
      const memberId = member.memberUser?.userId || member.memberUserId || member.userId;
      return Number(memberId) === Number(userId);
    })
  );
}

export function redirectIfNotCanvasEditor(auth: any, canvas: any): boolean {
  if (!canvas) {
    return false;
  }
  const userId = auth?.user?.id;
  if (isPlatformAdmin(auth)) {
    return false;
  }
  if (userId && Number(canvas.owner) === Number(userId)) {
    return false;
  }
  if (isCanvasMember(auth, canvas)) {
    return false;
  }

  const nextBase = (process.env.REACT_APP_NEXT_URL || "https://beautista.com").replace(/\/$/, "");
  const dest = canvas.slug ? `${nextBase}/canvas/${canvas.slug}` : `${nextBase}/portfolio`;
  window.location.replace(dest);
  return true;
}
